import { State } from '../reducers/types'

export const getAuthToken = (state: State): string | null => state.auth.authToken

export const getIsTokenSignIn = (state: State): boolean | null => state.auth.isTokenSignIn

export const getContractorPortalAuthToken = (state: State): string | null =>
  state.contractorPortalAuth.contractorPortalAuthToken
